import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { GrCheckbox, GrHelperMessage, GrLabel, GrTypography } from ".";
import { GrStack } from "../layout";
import { palette } from "../../theme/palette";
import styled from "@emotion/styled";
import { MenuItem, OutlinedInput, Select } from "@mui/material";
import classNames from "classnames";
import { useLayoutEffect, useState } from "react";
import { GrBadge } from "../data";
import { GrIcon } from "../icons/GrIcon";
export const StyledSelectOptionTypography = (props) => {
    return (_jsx(GrTypography, { type: props.size === "large"
            ? props.checked
                ? "Content.Subtitle02"
                : "Content.Body02"
            : props.size === "medium"
                ? props.checked
                    ? "Content.Subtitle03"
                    : "Content.Body03"
                : props.checked
                    ? "Content.Subtitle04"
                    : "Content.Body04", color: props.disabled ? "grey050" : props.checked ? "blue060" : "grey090", children: props.text }));
};
const StyledSelectFieldTypography = ({ size, disabled, isEmpty, text, readOnly, }) => {
    return (_jsx(GrTypography, { type: size === "large" ? "Content.Subtitle02" : size === "medium" ? "Content.Subtitle03" : "Content.Subtitle04", color: (isEmpty && "grey040") || (disabled && "grey030") || (readOnly && "grey060") || "grey090", style: {
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            overflow: "hidden",
            padding: "0 2px",
        }, children: text }));
};
const StyledRotate = styled("div")(({ open }) => ({
    transition: "all 0.2s",
    transform: `rotate(${open ? 180 : 0}deg)`,
}));
const StyledMenuItem = styled(MenuItem)(({ size, multiple, style }) => ({
    "&.MuiMenuItem-root": {
        minWidth: size === "large" ? "202px" : size === "medium" ? "162px" : "72px",
        padding: "7px 10px",
        height: size === "large" ? "36px" : size === "medium" ? "34px" : "32px",
        backgroundColor: palette.white,
        borderRadius: multiple ? "none" : "6px",
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        "&:hover": {
            backgroundColor: palette.grey010,
        },
        "&.Mui-disabled": {
            opacity: 1,
        },
        "&.Mui-selected": {
            backgroundColor: palette.blue015,
            "&.Mui-disabled": {
                backgroundColor: palette.white,
            },
        },
    },
    ...style,
}));
const StyledField = styled(OutlinedInput)(({ size, disabled, error, open, readOnly, style, variant }) => ({
    display: "inline-flex",
    border: `1px solid ${(variant === "text" && "transparent !important") || (open && palette["maven-blue-dark"]) || (error && palette.red050) || palette.grey025}`,
    borderRadius: "6px",
    backgroundColor: disabled || readOnly ? palette.grey010 : palette.white,
    width: (variant === "text" && "auto") || (size === "large" ? "202px" : size === "medium" ? "162px" : "106px"),
    padding: size === "large" ? "9px 8px" : size === "medium" ? "6px 8px" : "3px 8px",
    height: size === "large" ? "40px" : size === "medium" ? "32px" : "24px",
    "&:hover": {
        borderColor: palette.grey030,
    },
    "& .MuiSelect-select": {
        display: "flex",
        alignContent: "center",
        alignItems: "center",
        justifyContent: "space-between",
        padding: 0,
    },
    margin: 0,
    ".MuiOutlinedInput-notchedOutline": {
        border: "none",
    },
    ".Mui-disabled": {
        "-webkit-text-fill-color": palette.grey030,
    },
    ...style,
}));
export function GrSelect(props) {
    var _a, _b, _c, _d, _e, _f, _g;
    const { label, size = "medium", helperText, required, disabled, placeholder, fullWidth, fieldStyle = "normal", optionStyle = "normal", hasNoneOption, className, error, variant = "box", style, } = props;
    const [selectedValue, setSelectedValue] = useState(props.multiple ? [] : undefined);
    const [open, setOpen] = useState(false);
    useLayoutEffect(() => {
        setSelectedValue(props.value);
    }, [props.value]);
    function handleChange(e) {
        var _a;
        const v = e.target.value;
        let output = v;
        // NOTE: 값의 array 여부와 bigint 여부에 따라 분기로 처리
        const isBigint = (props.multiple &&
            typeof props.options[0] === "object" &&
            "value" in props.options[0] &&
            typeof props.options[0].value === "bigint") ||
            (!props.multiple && !Array.isArray(v) && typeof props.options[0] === "bigint");
        if (isBigint) {
            // NOTE: Bigint 이면서 Array 인 경우
            if (props.multiple && Array.isArray(v)) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                output = v.map(x => {
                    return BigInt(x);
                });
            }
            // NOTE: Bigint 이면서 Array 가 아닌 경우
            else if (!props.multiple && !Array.isArray(v)) {
                output = BigInt(v);
            }
        }
        setSelectedValue(output);
        (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, e, output);
    }
    return (_jsxs(GrStack, { className: "GrSelect-wrapper", display: "inline-flex", flexDirection: (_a = label === null || label === void 0 ? void 0 : label.flexDirection) !== null && _a !== void 0 ? _a : "column", width: fullWidth ? "100%" : undefined, gap: (_b = label === null || label === void 0 ? void 0 : label.gap) !== null && _b !== void 0 ? _b : (((_c = label === null || label === void 0 ? void 0 : label.flexDirection) === null || _c === void 0 ? void 0 : _c.includes("row")) ? "24px" : "6px"), children: [!(fieldStyle === "badge") && (label === null || label === void 0 ? void 0 : label.text) && (_jsx(GrLabel, { style: {
                    margin: ((_d = label === null || label === void 0 ? void 0 : label.flexDirection) === null || _d === void 0 ? void 0 : _d.includes("row")) ? "6px 0 0 0" : "0",
                    ...label === null || label === void 0 ? void 0 : label.style,
                }, required: required, disabled: props.disabled, text: label.text, size: ((_e = label === null || label === void 0 ? void 0 : label.flexDirection) === null || _e === void 0 ? void 0 : _e.includes("row")) ? size : "extraSmall" })), _jsxs(GrStack, { flexDirection: (_f = helperText === null || helperText === void 0 ? void 0 : helperText.flexDirection) !== null && _f !== void 0 ? _f : "column", gap: (_g = helperText === null || helperText === void 0 ? void 0 : helperText.gap) !== null && _g !== void 0 ? _g : "6px", width: fullWidth ? "100%" : undefined, className: classNames("GrSelect", className), overflow: "hidden", children: [_jsxs(Select, { id: props.id, autoFocus: props.autoFocus, value: selectedValue || "", disabled: disabled, onChange: handleChange, readOnly: props.readOnly, displayEmpty: true, error: !!error, multiple: props.multiple, renderValue: renderValue(props, size, selectedValue, placeholder), onFocus: e => {
                            var _a;
                            (_a = props.onFocus) === null || _a === void 0 ? void 0 : _a.call(props, e);
                        }, onBlur: e => {
                            var _a;
                            (_a = props.onBlur) === null || _a === void 0 ? void 0 : _a.call(props, e);
                        }, onOpen: e => {
                            var _a;
                            (_a = props.onOpen) === null || _a === void 0 ? void 0 : _a.call(props, e);
                            setOpen(true);
                        }, onClose: e => {
                            var _a;
                            (_a = props.onClose) === null || _a === void 0 ? void 0 : _a.call(props, e);
                            setOpen(false);
                        }, IconComponent: classes => (_jsx(StyledRotate, { ...classes, open: open, children: _jsx(GrIcon, { type: "chevron-down", size: 14, color: disabled ? "grey025" : "grey050" }) })), input: _jsx(StyledField, { size: size, fullWidth: fullWidth, open: open, style: style, variant: variant }), MenuProps: {
                            style: {
                                marginTop: "6px",
                            },
                            PaperProps: {
                                style: {
                                    margin: "0",
                                    padding: "0 4px",
                                    borderRadius: "6px",
                                    boxShadow: `0px 4px 16px 0px ${palette.black}1A`,
                                },
                            },
                        }, children: [hasNoneOption && (_jsx(StyledMenuItem, { value: "", disableRipple: true, size: size, style: style, children: _jsx(GrTypography, { type: size === "large" ? "Content.Body02" : size === "medium" ? "Content.Body03" : "Content.Body04", color: "grey070", style: {
                                        whiteSpace: "nowrap",
                                        textOverflow: "ellipsis",
                                        overflow: "hidden",
                                        fontStyle: "italic",
                                    }, children: "None" }) })), props.options.map((option, index) => {
                                var _a;
                                // NOTE: Object Type 일때
                                if (typeof option === "object" && "label" in option && "value" in option) {
                                    const individualDisabled = option.disabled;
                                    return (_jsx(StyledMenuItem, { size: size, value: (_a = option.value) === null || _a === void 0 ? void 0 : _a.toString(), disabled: individualDisabled, disableRipple: true, multiple: props.multiple, style: style, children: _jsx(GrSelectLabel, { size: size, disabled: individualDisabled, option: option, selectedValue: selectedValue, optionStyle: optionStyle }) }, index));
                                }
                                else if (typeof option !== "object") {
                                    const value = typeof option === "string" || typeof option === "number" ? option : option.toString();
                                    return (_jsx(StyledMenuItem, { value: value, disableRipple: true, size: size, multiple: props.multiple, style: style, children: _jsx(GrSelectLabel, { size: size, option: option, selectedValue: selectedValue, optionStyle: optionStyle }) }, index));
                                }
                                return _jsx(_Fragment, {});
                            })] }), (helperText === null || helperText === void 0 ? void 0 : helperText.text) && (_jsx(GrHelperMessage, { disabled: props.disabled, error: error, text: helperText.text, style: helperText === null || helperText === void 0 ? void 0 : helperText.style, hasIcon: helperText.hasIcon }))] })] }));
}
function GrSelectLabel(props) {
    var _a, _b;
    let label = "";
    let value;
    if (typeof props.option === "object" && "value" in props.option) {
        label = props.option.label.toString();
        value = props.option.value;
    }
    else {
        label = props.option.toString();
        value = props.option;
    }
    let checked = false;
    if (Array.isArray(props.selectedValue)) {
        checked = props.selectedValue.includes(value);
    }
    else {
        checked = props.selectedValue === value;
    }
    if (props.optionStyle === "checkbox") {
        return (_jsxs(GrStack, { display: "flex", flexDirection: "row", alignItems: "center", gap: "6px", height: "18px", children: [_jsx(GrCheckbox, { checked: checked, disabled: props.disabled, size: "medium", style: { padding: "0" } }), _jsx(StyledSelectOptionTypography, { size: (_a = props.size) !== null && _a !== void 0 ? _a : "medium", disabled: props.disabled, checked: checked, text: label })] }));
    }
    return _jsx(StyledSelectOptionTypography, { size: (_b = props.size) !== null && _b !== void 0 ? _b : "medium", disabled: props.disabled, checked: checked, text: label });
}
function renderValue(props, size, selectedValue, placeholder) {
    if (props.fieldStyle === "badge") {
        return selectedValue => _renderBadge(selectedValue);
    }
    else {
        if (Array.isArray(selectedValue) && selectedValue.length === 0)
            return () => (_jsx(StyledSelectFieldTypography, { isEmpty: true, size: size, readOnly: props.readOnly, disabled: props.disabled, text: placeholder !== null && placeholder !== void 0 ? placeholder : "" }));
        else if (selectedValue === undefined)
            return () => (_jsx(StyledSelectFieldTypography, { isEmpty: true, size: size, readOnly: props.readOnly, disabled: props.disabled, text: placeholder !== null && placeholder !== void 0 ? placeholder : "" }));
        else if (typeof selectedValue === "string" && selectedValue === "")
            return () => (_jsx(StyledSelectFieldTypography, { isEmpty: true, size: size, readOnly: props.readOnly, disabled: props.disabled, text: placeholder !== null && placeholder !== void 0 ? placeholder : "" }));
        return () => {
            const selectedLabels = _getLabelFromValue(selectedValue);
            return (_jsx(StyledSelectFieldTypography, { size: size, readOnly: props.readOnly, disabled: props.disabled, text: selectedLabels.join(", ") }));
        };
    }
    function _getLabelFromValue(value) {
        const values = Array.isArray(value) ? value : [value];
        const labels = values.map(value => {
            const option = props.options.find(x => (typeof x === "object" && String(x.value) === String(value)) || x === value);
            return typeof option === "object" ? option === null || option === void 0 ? void 0 : option.label.toString() : value.toString();
        });
        return labels;
    }
    /** Badge 형식으로 렌더를 원할 경우 렌더링 하는 함수 */
    function _renderBadge(selectedValue) {
        var _a, _b;
        const selectedValues = Array.isArray(selectedValue) ? selectedValue : [selectedValue];
        if (selectedValues.length === 0)
            return (_jsx(StyledSelectFieldTypography, { isEmpty: true, size: size, readOnly: props.readOnly, disabled: props.disabled, text: placeholder !== null && placeholder !== void 0 ? placeholder : "" }));
        return (_jsxs(_Fragment, { children: [_jsx(StyledSelectFieldTypography, { size: size, readOnly: props.readOnly, disabled: props.disabled, text: (_b = (_a = props.label) === null || _a === void 0 ? void 0 : _a.text) !== null && _b !== void 0 ? _b : "" }), !props.disabled && (_jsx(GrBadge, { count: selectedValues.length, size: size, variant: size === "small" ? "dot" : "standard", backgroundColor: "navy" }))] }));
    }
}
//# sourceMappingURL=GrSelect.js.map